import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { useStyles } from '../useStyles';
import { useFilters } from '../../Provider';

const LotTypeFilter: React.FC = () => {
  const { t } = useTranslation('tenders');
  const theme = useTheme();
  const { classes } = useStyles({ theme });
  const { selectedFilters, setField, lotTypes } = useFilters();

  const handleToggleType = (id: string) => {
    const current = selectedFilters.type;
    const newTypes = current?.includes(id)
      ? current.filter((x) => x !== id)
      : [...(current ?? []), id];
    setField('type', newTypes);
  };

  const current = selectedFilters.type;
  const handleResetType = () => {
    setField('type', []);
  };

  return (
    <Stack
      direction={{ lg: 'row', md: 'column', xs: 'column' }}
      gap={{ xs: 1.25, lg: 2.5 }}
    >
      <Typography width="100%" maxWidth={120} fontWeight={700}>
        {t('tenders.modal.lotType')}
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={1.25}>
        <Box
          key="any"
          className={clsx(classes.filter, {
            [classes.selectedFilter]: current?.length === 0,
          })}
          sx={{
            border: '1px solid',
            borderColor: current?.length === 0 ? 'primary.main' : 'grey.500',
            backgroundColor: 'white',
            cursor: 'pointer',
          }}
          onClick={handleResetType}
        >
          <Typography color="grey.500">{t('tenders.lotType.any')}</Typography>
        </Box>
        {lotTypes?.map((lot) => {
          const id = String(lot.id);
          const isSelected = selectedFilters?.type?.includes(id);
          return (
            <Box
              key={id}
              className={clsx(classes.filter, {
                [classes.selectedFilter]: isSelected,
              })}
              sx={{
                border: '1px solid',
                borderColor: isSelected ? 'primary.main' : 'grey.500',
                backgroundColor: 'white',
                cursor: 'pointer',
              }}
              onClick={() => handleToggleType(id)}
            >
              <Typography>{lot.name}</Typography>
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default LotTypeFilter;
